<template>
  <div v-if="data.acf_fields" :class="$style.subscribeNewsletter">
    <div :class="$style.subscribeNewsletter_wrap">
      <h2 :class="$style.subscribeNewsletter__title">
        <p>{{ data.acf_fields.form_title }}</p>
      </h2>
      <UiBaseButton
        v-if="!isMember"
        :class="$style.subscribeNewsletter__button"
        :text="'sign up now'"
        variant="black"
        content-type="text"
        @click="openNewsletter"
      />
      <UiBaseButton
        v-if="isMember"
        :class="$style.subscribeNewsletter__button"
        :text="'Go to Events'"
        variant="black"
        content-type="text"
        @click="goToCalendar"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import NewsLetterModal from '~/components/modals/NewsLetter/Modal.vue'

import { newsLetterModalProps } from '~/consts/modalOptions'

import type { SubscribeForm } from '~/components/wip/subscribe-newsletter/SubscribeNewsletter'

defineProps<{
  data: {
    acf_fields: SubscribeForm
  }
}>()

const nuxtApp = useNuxtApp()
const modalManager = nuxtApp.$modalManager as IModalManager
const router = useRouter()

const isMember = useUserStore().user.info.club_member

const openNewsletter = (): void => {
  modalManager.showModal(NewsLetterModal as object as ModalComponent, newsLetterModalProps)
}

const goToCalendar = (): void => {
  router.push('/calendar')
}
</script>

<style lang="scss" module>
.subscribeNewsletter {
  margin: var(--gutter-desktop) auto 0;

  &_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    background: v.$color-black;
    border-radius: 0.625rem;
    padding: 2.15625rem 1rem;
  }

  &__title {
    @include t.text-announcement;

    & {
      color: v.$color-white;
      margin: 0 auto;
      width: fit-content;
      display: flex;
      align-items: center;
      margin-bottom: 1.875rem;
    }

    p {
      padding: 0 1.25rem;
    }

    @include v.to(mobile) {
      text-align: center;
    }
  }

  &__button {
    border: 1px solid #fff;
    border-radius: 30px;
  }

  @include v.to(mobile) {
    margin: var(--gutter-mobile) 0;
  }
}
</style>
